import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from 'assets/kore.svg'


import Tooltip from 'components/Tooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'KoreBadge',
  props: {
    scale: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { scale: number };



return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createBlock(_component_q_img, {
    height: "10px",
    src: _imports_0,
    style: _normalizeStyle(`transform: scale(${__props.scale})`),
    width: "32px"
  }, {
    default: _withCtx(() => [
      _createVNode(Tooltip, null, {
        default: _withCtx(() => [
          _createTextVNode("from KORE Wireless")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})